module.exports = __webpack_public_path__ + "static/img/tp.5ad5e81.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/imgs/tp.gif
// module id = O5Ti
// module chunks = 1